// 폰 제스처의 판정 — DOM 없는 순수 함수 (spec docs/superpowers/specs/2026-09-25-phone-landscape-design.md §E.1).
// 손가락을 추적하는 쪽은 touch-gestures.js 이고, 여기는 "그래서 무엇을 할까" 만 정한다
// (단위 테스트 tests/unit/gesture-logic.test.mjs).

// 축을 정하기 전의 여유 — 이 안에서는 스크롤인지 제스처인지 모른다.
export const SLOP = 10;
// 당겨서 새로고침: 표시가 이만큼 내려오면 놓았을 때 새로 고친다.
export const PULL_THRESHOLD = 72;
const PULL_MAX = 120;

// 처음 움직임에서 축을 고른다: 한쪽이 다른 쪽의 ratio 배를 넘을 때만 — 대각선은 다음 이동에서 다시 본다.
export function lockAxis(dx, dy, slop = SLOP, ratio = 1.2) {
    const ax = Math.abs(dx);
    const ay = Math.abs(dy);
    if (Math.max(ax, ay) < slop) return null;
    if (ax >= ay * ratio) return 'x';
    if (ay >= ax * ratio) return 'y';
    return null;
}

// 놓았을 때 실행할까: delta 는 실행 방향으로 잰 거리(양수 = 그쪽), velocity 도 같은 방향의 px/ms.
// 거꾸로 튕기면 거리와 무관하게 되돌아가고, 짧은 튕김도 조금은(16px) 움직여야 한다.
export function releaseDecision({ delta, velocity = 0, size, ratio = 0.3, flick = 0.5 }) {
    if (!(delta > 0)) return false;
    if (velocity <= -flick) return false;
    if (delta >= size * ratio) return true;
    return velocity >= flick && delta >= 16;
}

// 저항: 끌수록 덜 따라오고 limit 을 넘지 않는다(고무줄).
export function resist(offset, limit) {
    if (!offset) return 0;
    const sign = offset < 0 ? -1 : 1;
    const x = Math.abs(offset);
    return sign * limit * (1 - 1 / ((x / limit) * 0.55 + 1));
}

// 기간 넘기기: 옛 일정 스와이프와 같은 기준(가로 60px 이상, 세로의 1.5배 이상). 왼쪽으로 밀면 다음.
export function periodSwipe(dx, dy, min = 60, ratio = 1.5) {
    const ax = Math.abs(dx);
    if (ax < min || ax < Math.abs(dy) * ratio) return null;
    return dx < 0 ? 'next' : 'prev';
}

// 당겨서 새로고침: 표시는 손가락의 절반 속도로 따라오고 PULL_MAX 에서 멈춘다.
export function pullState(dy, threshold = PULL_THRESHOLD, max = PULL_MAX) {
    if (!(dy > 0)) return { offset: 0, ready: false };
    const offset = Math.min(max, dy * 0.5);
    return { offset, ready: offset >= threshold };
}

// 마지막 100ms 의 속도(px/ms). samples = [{t, v}] (t 는 ms, v 는 그 축의 위치).
export function velocityOf(samples) {
    if (!samples || samples.length < 2) return 0;
    const last = samples[samples.length - 1];
    let first = last;
    for (let i = samples.length - 1; i >= 0; i--) {
        if (last.t - samples[i].t > 100) break;
        first = samples[i];
    }
    const dt = last.t - first.t;
    return dt > 0 ? (last.v - first.v) / dt : 0;
}
